import { LegalLayout, H2 } from "@/pages/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Rules & Regulations / Terms & Conditions" updated="June 2026">
      <p>
        Welcome to Your Varsity Application ("YVA", "we", "us"). By creating a profile and using our
        platform, you agree to these Rules & Regulations. Please read them carefully. If you do not
        agree, you may not use the service.
      </p>

      <H2>1. Our Service</H2>
      <p>
        YVA helps prospective students calculate their Admission Point Score (APS), discover the
        university courses they qualify for based on published admission requirements, and submit
        applications to participating universities. We are an independent facilitation service and are
        not the university itself. Final admission decisions rest solely with each university.
      </p>

      <H2>2. Your Profile & Accurate Information</H2>
      <p>
        You must register using a valid email address and create a secure password. You are responsible
        for the accuracy of the marks and personal information you enter. APS is calculated on the
        standard South African NSC 7-point scale using your best six subjects, <strong>excluding Life
        Orientation</strong>, in line with university standards.
      </p>

      <H2>3. Course Unlock Fee (R26.99)</H2>
      <p>
        A once-off fee of <strong>R26.99</strong> is required to unlock and view the full list of
        courses you qualify for. This fee is <strong>non-refundable</strong>. This term is binding and
        is protected under the applicable consumer and electronic transaction laws of the Republic of
        South Africa, as this is a digital product delivered immediately upon payment.
      </p>

      <H2>4. University Application Fee (R77.99)</H2>
      <p>
        Each university application submitted through YVA costs <strong>R77.99</strong>. This fee is
        <strong> refundable</strong> if the application is not submitted to the relevant university.
        Once an application has been submitted on your behalf, the fee is no longer refundable.
      </p>

      <H2>5. Payments</H2>
      <p>
        All payments are securely processed by Paystack. We do not store your card details. All amounts
        are in South African Rand (ZAR). By paying, you authorise the relevant charge.
      </p>

      <H2>6. Refunds</H2>
      <p>
        Refund requests for eligible application fees must be submitted through your account. The R26.99
        unlock fee is not eligible for a refund under any circumstances.
      </p>

      <H2>7. Operating Hours</H2>
      <p>
        Support and application processing are handled during standard business days (Monday to Friday).
        Automated features remain available at all times.
      </p>

      <H2>8. Limitation of Liability</H2>
      <p>
        Admission requirements and closing dates are published by universities and may change without
        notice. While we make every effort to keep information accurate, YVA is not liable for changes
        made by universities or for admission outcomes.
      </p>

      <H2>9. Changes to These Terms</H2>
      <p>We may update these Rules & Regulations from time to time. Continued use constitutes acceptance.</p>
    </LegalLayout>
  );
}
